// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/coins/v2/service.proto (package creativefabrica.coins.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ActionPricing, ActionPricingJson, AutoTopUpPack, AutoTopUpPackJson, AutoTopUpSettings, AutoTopUpSettingsJson, PricingAction, PricingActionJson, StatisticsPeriod, StatisticsPeriodJson, TeamApiKeyStats, TeamApiKeyStatsJson, TeamMemberStats, TeamMemberStatsJson, TeamSettings, TeamSettingsJson, Transaction, TransactionJson, UserTransactionStats, UserTransactionStatsJson } from "./types_pb";
import { file_creativefabrica_coins_v2_types } from "./types_pb";
import type { Surface, SurfaceJson } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import { file_creativefabrica_common_v1_surface_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import type { PaginationRequest, PaginationRequestJson, PaginationResponse, PaginationResponseJson } from "@repo/rpc-types-creativefabrica-common-v1";
import { file_creativefabrica_common_v1_types } from "@repo/rpc-types-creativefabrica-common-v1";
import type { TeamAvatarStatus, TeamAvatarStatusJson } from "../../teams/v2/types_pb";
import { file_creativefabrica_teams_v2_types } from "../../teams/v2/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/coins/v2/service.proto.
 */
export const file_creativefabrica_coins_v2_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_coins_v2_types, file_creativefabrica_common_v1_surface_v1_types, file_creativefabrica_common_v1_types, file_creativefabrica_teams_v2_types]);

/**
 * @generated from message creativefabrica.coins.v2.GetPricingRequest
 */
export type GetPricingRequest = Message<"creativefabrica.coins.v2.GetPricingRequest"> & {
  /**
   * If set, the response contains pricing for just that action; otherwise
   * it contains pricing for every known action.
   *
   * @generated from field: optional creativefabrica.coins.v2.PricingAction action = 1;
   */
  action?: PricingAction | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.GetPricingRequest
 */
export type GetPricingRequestJson = {
  /**
   * If set, the response contains pricing for just that action; otherwise
   * it contains pricing for every known action.
   *
   * @generated from field: optional creativefabrica.coins.v2.PricingAction action = 1;
   */
  action?: PricingActionJson;
};

/**
 * Describes the message creativefabrica.coins.v2.GetPricingRequest.
 * Use `create(GetPricingRequestSchema)` to create a new message.
 */
export const GetPricingRequestSchema: GenMessage<GetPricingRequest, {jsonType: GetPricingRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 0);

/**
 * @generated from message creativefabrica.coins.v2.GetPricingResponse
 */
export type GetPricingResponse = Message<"creativefabrica.coins.v2.GetPricingResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.coins.v2.ActionPricing items = 1;
   */
  items: ActionPricing[];
};

/**
 * @generated from message creativefabrica.coins.v2.GetPricingResponse
 */
export type GetPricingResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.coins.v2.ActionPricing items = 1;
   */
  items?: ActionPricingJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.GetPricingResponse.
 * Use `create(GetPricingResponseSchema)` to create a new message.
 */
export const GetPricingResponseSchema: GenMessage<GetPricingResponse, {jsonType: GetPricingResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 1);

/**
 * The authenticated user is inferred from the request context.
 *
 * @generated from message creativefabrica.coins.v2.GetBalanceRequest
 */
export type GetBalanceRequest = Message<"creativefabrica.coins.v2.GetBalanceRequest"> & {
};

/**
 * The authenticated user is inferred from the request context.
 *
 * @generated from message creativefabrica.coins.v2.GetBalanceRequest
 */
export type GetBalanceRequestJson = {
};

/**
 * Describes the message creativefabrica.coins.v2.GetBalanceRequest.
 * Use `create(GetBalanceRequestSchema)` to create a new message.
 */
export const GetBalanceRequestSchema: GenMessage<GetBalanceRequest, {jsonType: GetBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 2);

/**
 * @generated from message creativefabrica.coins.v2.GetBalanceResponse
 */
export type GetBalanceResponse = Message<"creativefabrica.coins.v2.GetBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;

  /**
   * @generated from field: int64 team_balance = 2;
   */
  teamBalance: bigint;

  /**
   * @generated from field: int64 team_user_balance = 3;
   */
  teamUserBalance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.GetBalanceResponse
 */
export type GetBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;

  /**
   * @generated from field: int64 team_balance = 2;
   */
  teamBalance?: string;

  /**
   * @generated from field: int64 team_user_balance = 3;
   */
  teamUserBalance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetBalanceResponse.
 * Use `create(GetBalanceResponseSchema)` to create a new message.
 */
export const GetBalanceResponseSchema: GenMessage<GetBalanceResponse, {jsonType: GetBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 3);

/**
 * The authenticated user is inferred from the request context.
 * An omitted surface means studio, so callers that predate the field keep
 * the studio settings they always read.
 *
 * @generated from message creativefabrica.coins.v2.GetAutoTopUpSettingsRequest
 */
export type GetAutoTopUpSettingsRequest = Message<"creativefabrica.coins.v2.GetAutoTopUpSettingsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 1;
   */
  surface: Surface;
};

/**
 * The authenticated user is inferred from the request context.
 * An omitted surface means studio, so callers that predate the field keep
 * the studio settings they always read.
 *
 * @generated from message creativefabrica.coins.v2.GetAutoTopUpSettingsRequest
 */
export type GetAutoTopUpSettingsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 1;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.coins.v2.GetAutoTopUpSettingsRequest.
 * Use `create(GetAutoTopUpSettingsRequestSchema)` to create a new message.
 */
export const GetAutoTopUpSettingsRequestSchema: GenMessage<GetAutoTopUpSettingsRequest, {jsonType: GetAutoTopUpSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 4);

/**
 * @generated from message creativefabrica.coins.v2.GetAutoTopUpSettingsResponse
 */
export type GetAutoTopUpSettingsResponse = Message<"creativefabrica.coins.v2.GetAutoTopUpSettingsResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.AutoTopUpSettings settings = 1;
   */
  settings?: AutoTopUpSettings | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.GetAutoTopUpSettingsResponse
 */
export type GetAutoTopUpSettingsResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.AutoTopUpSettings settings = 1;
   */
  settings?: AutoTopUpSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.GetAutoTopUpSettingsResponse.
 * Use `create(GetAutoTopUpSettingsResponseSchema)` to create a new message.
 */
export const GetAutoTopUpSettingsResponseSchema: GenMessage<GetAutoTopUpSettingsResponse, {jsonType: GetAutoTopUpSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 5);

/**
 * Updates one or both settings atomically. At least one field must be set.
 * The authenticated user is inferred from the request context.
 * An omitted surface means studio.
 *
 * @generated from message creativefabrica.coins.v2.UpdateAutoTopUpSettingsRequest
 */
export type UpdateAutoTopUpSettingsRequest = Message<"creativefabrica.coins.v2.UpdateAutoTopUpSettingsRequest"> & {
  /**
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean | undefined;

  /**
   * @generated from field: optional creativefabrica.coins.v2.AutoTopUpPack pack = 2;
   */
  pack?: AutoTopUpPack | undefined;

  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface: Surface;
};

/**
 * Updates one or both settings atomically. At least one field must be set.
 * The authenticated user is inferred from the request context.
 * An omitted surface means studio.
 *
 * @generated from message creativefabrica.coins.v2.UpdateAutoTopUpSettingsRequest
 */
export type UpdateAutoTopUpSettingsRequestJson = {
  /**
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * @generated from field: optional creativefabrica.coins.v2.AutoTopUpPack pack = 2;
   */
  pack?: AutoTopUpPackJson;

  /**
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateAutoTopUpSettingsRequest.
 * Use `create(UpdateAutoTopUpSettingsRequestSchema)` to create a new message.
 */
export const UpdateAutoTopUpSettingsRequestSchema: GenMessage<UpdateAutoTopUpSettingsRequest, {jsonType: UpdateAutoTopUpSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 6);

/**
 * @generated from message creativefabrica.coins.v2.UpdateAutoTopUpSettingsResponse
 */
export type UpdateAutoTopUpSettingsResponse = Message<"creativefabrica.coins.v2.UpdateAutoTopUpSettingsResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.AutoTopUpSettings settings = 1;
   */
  settings?: AutoTopUpSettings | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.UpdateAutoTopUpSettingsResponse
 */
export type UpdateAutoTopUpSettingsResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.AutoTopUpSettings settings = 1;
   */
  settings?: AutoTopUpSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateAutoTopUpSettingsResponse.
 * Use `create(UpdateAutoTopUpSettingsResponseSchema)` to create a new message.
 */
export const UpdateAutoTopUpSettingsResponseSchema: GenMessage<UpdateAutoTopUpSettingsResponse, {jsonType: UpdateAutoTopUpSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 7);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamSettingsRequest
 */
export type GetTeamSettingsRequest = Message<"creativefabrica.coins.v2.GetTeamSettingsRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamSettingsRequest
 */
export type GetTeamSettingsRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamSettingsRequest.
 * Use `create(GetTeamSettingsRequestSchema)` to create a new message.
 */
export const GetTeamSettingsRequestSchema: GenMessage<GetTeamSettingsRequest, {jsonType: GetTeamSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 8);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamSettingsResponse
 */
export type GetTeamSettingsResponse = Message<"creativefabrica.coins.v2.GetTeamSettingsResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 1;
   */
  settings?: TeamSettings | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamSettingsResponse
 */
export type GetTeamSettingsResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 1;
   */
  settings?: TeamSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamSettingsResponse.
 * Use `create(GetTeamSettingsResponseSchema)` to create a new message.
 */
export const GetTeamSettingsResponseSchema: GenMessage<GetTeamSettingsResponse, {jsonType: GetTeamSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 9);

/**
 * Replaces the team's coin settings with the given values.
 *
 * @generated from message creativefabrica.coins.v2.UpdateTeamSettingsRequest
 */
export type UpdateTeamSettingsRequest = Message<"creativefabrica.coins.v2.UpdateTeamSettingsRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 2;
   */
  settings?: TeamSettings | undefined;
};

/**
 * Replaces the team's coin settings with the given values.
 *
 * @generated from message creativefabrica.coins.v2.UpdateTeamSettingsRequest
 */
export type UpdateTeamSettingsRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 2;
   */
  settings?: TeamSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateTeamSettingsRequest.
 * Use `create(UpdateTeamSettingsRequestSchema)` to create a new message.
 */
export const UpdateTeamSettingsRequestSchema: GenMessage<UpdateTeamSettingsRequest, {jsonType: UpdateTeamSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 10);

/**
 * @generated from message creativefabrica.coins.v2.UpdateTeamSettingsResponse
 */
export type UpdateTeamSettingsResponse = Message<"creativefabrica.coins.v2.UpdateTeamSettingsResponse"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 1;
   */
  settings?: TeamSettings | undefined;
};

/**
 * @generated from message creativefabrica.coins.v2.UpdateTeamSettingsResponse
 */
export type UpdateTeamSettingsResponseJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.TeamSettings settings = 1;
   */
  settings?: TeamSettingsJson;
};

/**
 * Describes the message creativefabrica.coins.v2.UpdateTeamSettingsResponse.
 * Use `create(UpdateTeamSettingsResponseSchema)` to create a new message.
 */
export const UpdateTeamSettingsResponseSchema: GenMessage<UpdateTeamSettingsResponse, {jsonType: UpdateTeamSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 11);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMembersStatsRequest
 */
export type ListTeamMembersStatsRequest = Message<"creativefabrica.coins.v2.ListTeamMembersStatsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period: StatisticsPeriod;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMembersStatsRequest
 */
export type ListTeamMembersStatsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period?: StatisticsPeriodJson;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamMembersStatsRequest.
 * Use `create(ListTeamMembersStatsRequestSchema)` to create a new message.
 */
export const ListTeamMembersStatsRequestSchema: GenMessage<ListTeamMembersStatsRequest, {jsonType: ListTeamMembersStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 12);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMembersStatsResponse
 */
export type ListTeamMembersStatsResponse = Message<"creativefabrica.coins.v2.ListTeamMembersStatsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamMemberStats stats = 2;
   */
  stats: TeamMemberStats[];

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string avatar_thumbnail_url = 4;
   */
  avatarThumbnailUrl: string;

  /**
   * @generated from field: creativefabrica.teams.v2.TeamAvatarStatus avatar_status = 5;
   */
  avatarStatus: TeamAvatarStatus;
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamMembersStatsResponse
 */
export type ListTeamMembersStatsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamMemberStats stats = 2;
   */
  stats?: TeamMemberStatsJson[];

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl?: string;

  /**
   * @generated from field: string avatar_thumbnail_url = 4;
   */
  avatarThumbnailUrl?: string;

  /**
   * @generated from field: creativefabrica.teams.v2.TeamAvatarStatus avatar_status = 5;
   */
  avatarStatus?: TeamAvatarStatusJson;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamMembersStatsResponse.
 * Use `create(ListTeamMembersStatsResponseSchema)` to create a new message.
 */
export const ListTeamMembersStatsResponseSchema: GenMessage<ListTeamMembersStatsResponse, {jsonType: ListTeamMembersStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 13);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamApiKeyStatsRequest
 */
export type ListTeamApiKeyStatsRequest = Message<"creativefabrica.coins.v2.ListTeamApiKeyStatsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period: StatisticsPeriod;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamApiKeyStatsRequest
 */
export type ListTeamApiKeyStatsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period?: StatisticsPeriodJson;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamApiKeyStatsRequest.
 * Use `create(ListTeamApiKeyStatsRequestSchema)` to create a new message.
 */
export const ListTeamApiKeyStatsRequestSchema: GenMessage<ListTeamApiKeyStatsRequest, {jsonType: ListTeamApiKeyStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 14);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamApiKeyStatsResponse
 */
export type ListTeamApiKeyStatsResponse = Message<"creativefabrica.coins.v2.ListTeamApiKeyStatsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamApiKeyStats stats = 2;
   */
  stats: TeamApiKeyStats[];
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamApiKeyStatsResponse
 */
export type ListTeamApiKeyStatsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.TeamApiKeyStats stats = 2;
   */
  stats?: TeamApiKeyStatsJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamApiKeyStatsResponse.
 * Use `create(ListTeamApiKeyStatsResponseSchema)` to create a new message.
 */
export const ListTeamApiKeyStatsResponseSchema: GenMessage<ListTeamApiKeyStatsResponse, {jsonType: ListTeamApiKeyStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 15);

/**
 * @generated from message creativefabrica.coins.v2.ListUserTransactionStatsRequest
 */
export type ListUserTransactionStatsRequest = Message<"creativefabrica.coins.v2.ListUserTransactionStatsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period: StatisticsPeriod;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.ListUserTransactionStatsRequest
 */
export type ListUserTransactionStatsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 2;
   */
  period?: StatisticsPeriodJson;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListUserTransactionStatsRequest.
 * Use `create(ListUserTransactionStatsRequestSchema)` to create a new message.
 */
export const ListUserTransactionStatsRequestSchema: GenMessage<ListUserTransactionStatsRequest, {jsonType: ListUserTransactionStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 16);

/**
 * @generated from message creativefabrica.coins.v2.ListUserTransactionStatsResponse
 */
export type ListUserTransactionStatsResponse = Message<"creativefabrica.coins.v2.ListUserTransactionStatsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.UserTransactionStats usage_stats = 2;
   */
  usageStats: UserTransactionStats[];

  /**
   * @generated from field: int64 personal_coins_total = 3;
   */
  personalCoinsTotal: bigint;

  /**
   * @generated from field: int64 personal_coins_used = 4;
   */
  personalCoinsUsed: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.ListUserTransactionStatsResponse
 */
export type ListUserTransactionStatsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.UserTransactionStats usage_stats = 2;
   */
  usageStats?: UserTransactionStatsJson[];

  /**
   * @generated from field: int64 personal_coins_total = 3;
   */
  personalCoinsTotal?: string;

  /**
   * @generated from field: int64 personal_coins_used = 4;
   */
  personalCoinsUsed?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListUserTransactionStatsResponse.
 * Use `create(ListUserTransactionStatsResponseSchema)` to create a new message.
 */
export const ListUserTransactionStatsResponseSchema: GenMessage<ListUserTransactionStatsResponse, {jsonType: ListUserTransactionStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 17);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamStatisticsRequest
 */
export type GetTeamStatisticsRequest = Message<"creativefabrica.coins.v2.GetTeamStatisticsRequest"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 1;
   */
  period: StatisticsPeriod;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamStatisticsRequest
 */
export type GetTeamStatisticsRequestJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.StatisticsPeriod period = 1;
   */
  period?: StatisticsPeriodJson;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamStatisticsRequest.
 * Use `create(GetTeamStatisticsRequestSchema)` to create a new message.
 */
export const GetTeamStatisticsRequestSchema: GenMessage<GetTeamStatisticsRequest, {jsonType: GetTeamStatisticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 18);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamStatisticsResponse
 */
export type GetTeamStatisticsResponse = Message<"creativefabrica.coins.v2.GetTeamStatisticsResponse"> & {
  /**
   * @generated from field: int64 team_coins_balance = 1;
   */
  teamCoinsBalance: bigint;

  /**
   * @generated from field: int64 team_coins_spent = 2;
   */
  teamCoinsSpent: bigint;

  /**
   * @generated from field: int64 total_coins_balance = 3;
   */
  totalCoinsBalance: bigint;

  /**
   * @generated from field: int64 total_coins_spent = 4;
   */
  totalCoinsSpent: bigint;

  /**
   * @generated from field: int64 total_coins_spent_last_period = 5;
   */
  totalCoinsSpentLastPeriod: bigint;

  /**
   * @generated from field: int64 avg_coins_spent_per_user = 6;
   */
  avgCoinsSpentPerUser: bigint;

  /**
   * @generated from field: int64 avg_coins_spent_per_user_last_period = 7;
   */
  avgCoinsSpentPerUserLastPeriod: bigint;

  /**
   * Members holding an active seat now, and seats the team pays for.
   *
   * @generated from field: int64 active_members = 8;
   */
  activeMembers: bigint;

  /**
   * @generated from field: int64 total_paid_seats = 9;
   */
  totalPaidSeats: bigint;

  /**
   * API-key pool spend in the reported window and the previous window.
   * Already included in team_coins_spent / total_coins_spent via pool used.
   *
   * @generated from field: int64 api_key_coins_spent = 10;
   */
  apiKeyCoinsSpent: bigint;

  /**
   * @generated from field: int64 api_key_coins_spent_last_period = 11;
   */
  apiKeyCoinsSpentLastPeriod: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamStatisticsResponse
 */
export type GetTeamStatisticsResponseJson = {
  /**
   * @generated from field: int64 team_coins_balance = 1;
   */
  teamCoinsBalance?: string;

  /**
   * @generated from field: int64 team_coins_spent = 2;
   */
  teamCoinsSpent?: string;

  /**
   * @generated from field: int64 total_coins_balance = 3;
   */
  totalCoinsBalance?: string;

  /**
   * @generated from field: int64 total_coins_spent = 4;
   */
  totalCoinsSpent?: string;

  /**
   * @generated from field: int64 total_coins_spent_last_period = 5;
   */
  totalCoinsSpentLastPeriod?: string;

  /**
   * @generated from field: int64 avg_coins_spent_per_user = 6;
   */
  avgCoinsSpentPerUser?: string;

  /**
   * @generated from field: int64 avg_coins_spent_per_user_last_period = 7;
   */
  avgCoinsSpentPerUserLastPeriod?: string;

  /**
   * Members holding an active seat now, and seats the team pays for.
   *
   * @generated from field: int64 active_members = 8;
   */
  activeMembers?: string;

  /**
   * @generated from field: int64 total_paid_seats = 9;
   */
  totalPaidSeats?: string;

  /**
   * API-key pool spend in the reported window and the previous window.
   * Already included in team_coins_spent / total_coins_spent via pool used.
   *
   * @generated from field: int64 api_key_coins_spent = 10;
   */
  apiKeyCoinsSpent?: string;

  /**
   * @generated from field: int64 api_key_coins_spent_last_period = 11;
   */
  apiKeyCoinsSpentLastPeriod?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamStatisticsResponse.
 * Use `create(GetTeamStatisticsResponseSchema)` to create a new message.
 */
export const GetTeamStatisticsResponseSchema: GenMessage<GetTeamStatisticsResponse, {jsonType: GetTeamStatisticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 19);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamBalanceRequest
 */
export type GetTeamBalanceRequest = Message<"creativefabrica.coins.v2.GetTeamBalanceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamBalanceRequest
 */
export type GetTeamBalanceRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamBalanceRequest.
 * Use `create(GetTeamBalanceRequestSchema)` to create a new message.
 */
export const GetTeamBalanceRequestSchema: GenMessage<GetTeamBalanceRequest, {jsonType: GetTeamBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 20);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamBalanceResponse
 */
export type GetTeamBalanceResponse = Message<"creativefabrica.coins.v2.GetTeamBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamBalanceResponse
 */
export type GetTeamBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamBalanceResponse.
 * Use `create(GetTeamBalanceResponseSchema)` to create a new message.
 */
export const GetTeamBalanceResponseSchema: GenMessage<GetTeamBalanceResponse, {jsonType: GetTeamBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 21);

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamBalanceRequest
 */
export type AdjustTeamBalanceRequest = Message<"creativefabrica.coins.v2.AdjustTeamBalanceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: int64 delta = 2;
   */
  delta: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamBalanceRequest
 */
export type AdjustTeamBalanceRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: int64 delta = 2;
   */
  delta?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.AdjustTeamBalanceRequest.
 * Use `create(AdjustTeamBalanceRequestSchema)` to create a new message.
 */
export const AdjustTeamBalanceRequestSchema: GenMessage<AdjustTeamBalanceRequest, {jsonType: AdjustTeamBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 22);

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamBalanceResponse
 */
export type AdjustTeamBalanceResponse = Message<"creativefabrica.coins.v2.AdjustTeamBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamBalanceResponse
 */
export type AdjustTeamBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.AdjustTeamBalanceResponse.
 * Use `create(AdjustTeamBalanceResponseSchema)` to create a new message.
 */
export const AdjustTeamBalanceResponseSchema: GenMessage<AdjustTeamBalanceResponse, {jsonType: AdjustTeamBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 23);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamTransactionsRequest
 */
export type ListTeamTransactionsRequest = Message<"creativefabrica.coins.v2.ListTeamTransactionsRequest"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamTransactionsRequest
 */
export type ListTeamTransactionsRequestJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamTransactionsRequest.
 * Use `create(ListTeamTransactionsRequestSchema)` to create a new message.
 */
export const ListTeamTransactionsRequestSchema: GenMessage<ListTeamTransactionsRequest, {jsonType: ListTeamTransactionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 24);

/**
 * @generated from message creativefabrica.coins.v2.ListTeamTransactionsResponse
 */
export type ListTeamTransactionsResponse = Message<"creativefabrica.coins.v2.ListTeamTransactionsResponse"> & {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse | undefined;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.Transaction transactions = 2;
   */
  transactions: Transaction[];
};

/**
 * @generated from message creativefabrica.coins.v2.ListTeamTransactionsResponse
 */
export type ListTeamTransactionsResponseJson = {
  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponseJson;

  /**
   * @generated from field: repeated creativefabrica.coins.v2.Transaction transactions = 2;
   */
  transactions?: TransactionJson[];
};

/**
 * Describes the message creativefabrica.coins.v2.ListTeamTransactionsResponse.
 * Use `create(ListTeamTransactionsResponseSchema)` to create a new message.
 */
export const ListTeamTransactionsResponseSchema: GenMessage<ListTeamTransactionsResponse, {jsonType: ListTeamTransactionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 25);

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamMemberBalanceRequest
 */
export type AdjustTeamMemberBalanceRequest = Message<"creativefabrica.coins.v2.AdjustTeamMemberBalanceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: int64 delta = 3;
   */
  delta: bigint;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamMemberBalanceRequest
 */
export type AdjustTeamMemberBalanceRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: int64 delta = 3;
   */
  delta?: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.AdjustTeamMemberBalanceRequest.
 * Use `create(AdjustTeamMemberBalanceRequestSchema)` to create a new message.
 */
export const AdjustTeamMemberBalanceRequestSchema: GenMessage<AdjustTeamMemberBalanceRequest, {jsonType: AdjustTeamMemberBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 26);

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamMemberBalanceResponse
 */
export type AdjustTeamMemberBalanceResponse = Message<"creativefabrica.coins.v2.AdjustTeamMemberBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.AdjustTeamMemberBalanceResponse
 */
export type AdjustTeamMemberBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.AdjustTeamMemberBalanceResponse.
 * Use `create(AdjustTeamMemberBalanceResponseSchema)` to create a new message.
 */
export const AdjustTeamMemberBalanceResponseSchema: GenMessage<AdjustTeamMemberBalanceResponse, {jsonType: AdjustTeamMemberBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 27);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamMemberBalanceRequest
 */
export type GetTeamMemberBalanceRequest = Message<"creativefabrica.coins.v2.GetTeamMemberBalanceRequest"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamMemberBalanceRequest
 */
export type GetTeamMemberBalanceRequestJson = {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamMemberBalanceRequest.
 * Use `create(GetTeamMemberBalanceRequestSchema)` to create a new message.
 */
export const GetTeamMemberBalanceRequestSchema: GenMessage<GetTeamMemberBalanceRequest, {jsonType: GetTeamMemberBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 28);

/**
 * @generated from message creativefabrica.coins.v2.GetTeamMemberBalanceResponse
 */
export type GetTeamMemberBalanceResponse = Message<"creativefabrica.coins.v2.GetTeamMemberBalanceResponse"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.GetTeamMemberBalanceResponse
 */
export type GetTeamMemberBalanceResponseJson = {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.GetTeamMemberBalanceResponse.
 * Use `create(GetTeamMemberBalanceResponseSchema)` to create a new message.
 */
export const GetTeamMemberBalanceResponseSchema: GenMessage<GetTeamMemberBalanceResponse, {jsonType: GetTeamMemberBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_service, 29);

/**
 * CoinsService is the v2 Connect-RPC surface for the coins product.
 *
 * v2 starts with static pricing, authenticated balance reads and auto top-up
 * settings. Transaction list, spend, tip, admin, subscription-gating and
 * event-shaped RPCs all stay on v1 until they're individually justified for
 * migration. Start small; add later.
 *
 * @generated from service creativefabrica.coins.v2.CoinsService
 */
export const CoinsService: GenService<{
  /**
   * GetPricing returns static coin pricing for a single action or every
   * known action. Replaces the GetConfig spend-action breakdown for v2
   * clients. Surface-specific variants (e.g. Lumo) are encoded as distinct
   * PricingAction enum values.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetPricing
   */
  getPricing: {
    methodKind: "unary";
    input: typeof GetPricingRequestSchema;
    output: typeof GetPricingResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetBalance
   */
  getBalance: {
    methodKind: "unary";
    input: typeof GetBalanceRequestSchema;
    output: typeof GetBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetAutoTopUpSettings
   */
  getAutoTopUpSettings: {
    methodKind: "unary";
    input: typeof GetAutoTopUpSettingsRequestSchema;
    output: typeof GetAutoTopUpSettingsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.UpdateAutoTopUpSettings
   */
  updateAutoTopUpSettings: {
    methodKind: "unary";
    input: typeof UpdateAutoTopUpSettingsRequestSchema;
    output: typeof UpdateAutoTopUpSettingsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamSettings
   */
  getTeamSettings: {
    methodKind: "unary";
    input: typeof GetTeamSettingsRequestSchema;
    output: typeof GetTeamSettingsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.UpdateTeamSettings
   */
  updateTeamSettings: {
    methodKind: "unary";
    input: typeof UpdateTeamSettingsRequestSchema;
    output: typeof UpdateTeamSettingsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListTeamMembersStats
   */
  listTeamMembersStats: {
    methodKind: "unary";
    input: typeof ListTeamMembersStatsRequestSchema;
    output: typeof ListTeamMembersStatsResponseSchema;
  },
  /**
   * Lists coin usage for team API keys that spent in the period. Keys with
   * no spend are omitted. Spend is the apikey: tracking bucket overflow_used
   * and is already included in GetTeamStatistics team/total spent via pool used.
   *
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListTeamApiKeyStats
   */
  listTeamApiKeyStats: {
    methodKind: "unary";
    input: typeof ListTeamApiKeyStatsRequestSchema;
    output: typeof ListTeamApiKeyStatsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListUserTransactionStats
   */
  listUserTransactionStats: {
    methodKind: "unary";
    input: typeof ListUserTransactionStatsRequestSchema;
    output: typeof ListUserTransactionStatsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamStatistics
   */
  getTeamStatistics: {
    methodKind: "unary";
    input: typeof GetTeamStatisticsRequestSchema;
    output: typeof GetTeamStatisticsResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamBalance
   */
  getTeamBalance: {
    methodKind: "unary";
    input: typeof GetTeamBalanceRequestSchema;
    output: typeof GetTeamBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.GetTeamMemberBalance
   */
  getTeamMemberBalance: {
    methodKind: "unary";
    input: typeof GetTeamMemberBalanceRequestSchema;
    output: typeof GetTeamMemberBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.AdjustTeamBalance
   */
  adjustTeamBalance: {
    methodKind: "unary";
    input: typeof AdjustTeamBalanceRequestSchema;
    output: typeof AdjustTeamBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.AdjustTeamMemberBalance
   */
  adjustTeamMemberBalance: {
    methodKind: "unary";
    input: typeof AdjustTeamMemberBalanceRequestSchema;
    output: typeof AdjustTeamMemberBalanceResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.coins.v2.CoinsService.ListTeamTransactions
   */
  listTeamTransactions: {
    methodKind: "unary";
    input: typeof ListTeamTransactionsRequestSchema;
    output: typeof ListTeamTransactionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_coins_v2_service, 0);

